import tableAppFailedTransactions from './tableAppFailedTransactions';

export default {
  tabName: 'Failed transactions',
  title: '',
  attributeName: 'appFailedTransaction',
  getURL: 'appId/appFailedTransaction',
  createURL: '',
  removeURL: 'appId/appTransaction',
  sessionParams: ['appId'],
  isTable: true,
  noArea: true,
  tableConfig: tableAppFailedTransactions,
  href: '/test',
  eventKey: 'failed',
};
